import "./Modal.css";

const Modal = ({ children, isOpen, closeModal }) => {
  const handleModalContainerClick = (e) => e.stopPropagation();

  return (
    <article className={`modal ${isOpen && "is-open"}`} onClick={closeModal}>
      <div className="modal-container" onClick={handleModalContainerClick}>
        <button className="modal-close btn btn-danger" onClick={closeModal} style={{border: "none"}}>
          X
        </button>
        {children}
      </div>
    </article>
  );
};

export default Modal;